import { adjust, create, search } from 'assets/icons';
import { IssueTranslationKeys, CommonTranslationKeys, NotificationTranslationKeys } from 'intl/keys';
import { InfoBanner } from 'components/general/InfoBanner';
import React, { useMemo } from 'react';

export enum EmptyListReason {
  SEARCHPHRASE_MISMATCH = 'SEARCHPHRASE_MISMATCH',
  FILTER_MISMATCH = 'FILTER_MISMATCH',
  NOTHING_IN_DB = 'NOTHING_IN_DB',
  REQUEST_FAILED = 'REQUEST_FAILED',
}

interface EmptyTableInfoProps {
  emptyTableReason: EmptyListReason;
}

export const standardListComponentProps = {
  filterMismatch: {
    messageId: IssueTranslationKeys.noIssuesFiltersView,
    dataQa: 'no-filtering-results',
    icon: adjust,
  },
  searchPhraseMismatch: {
    icon: search,
    dataQa: 'no_search_results',
    messageId: IssueTranslationKeys.noIssuesSearchPhraseView,
  },
  nothingInDb: {
    messageId: CommonTranslationKeys.noData,
    dataQa: 'empty-list',
    icon: create,
  },
  requestFailed: {
    messageId: NotificationTranslationKeys.somethingWentWrong,
    dataQa: 'empty-list-request-failed',
    icon: adjust,
  },
};

function createComponentProps(reason: EmptyListReason): {
  icon: string;
  dataQa: string;
  messageId: string;
} {
  switch (reason) {
    case EmptyListReason.SEARCHPHRASE_MISMATCH:
      return standardListComponentProps.searchPhraseMismatch;
    case EmptyListReason.NOTHING_IN_DB:
      return standardListComponentProps.nothingInDb;
    case EmptyListReason.FILTER_MISMATCH:
      return standardListComponentProps.filterMismatch;
    case EmptyListReason.REQUEST_FAILED:
      return standardListComponentProps.requestFailed;
  }
}

export function EmptyTableInfo(
  props: EmptyTableInfoProps
): React.ReactElement {
  const { emptyTableReason } = props;

  const componentProps = useMemo(
    () => createComponentProps(emptyTableReason),
    [emptyTableReason]
  );

  return <InfoBanner {...componentProps} />;
}
